<script>
	import RoundRefresh from 'virtual:icons/ic/round-refresh';
	import '@lib/styles/app.css';
	import '@fontsource/poppins/300.css';
	import '@fontsource/poppins/400.css';
	import '@fontsource/poppins/500.css';
	import '@fontsource/poppins/600.css';
	import '@fontsource/poppins/700.css';
	import 'nprogress/nprogress.css';
	import NProgress from 'nprogress';
	import { Toaster } from 'svelte-sonner';
	import { merge } from 'lodash-es';
	import { MetaTags } from 'svelte-meta-tags';
	import { navigating, page, updated } from '$app/stores';
	import { additionalPaddingBottom, isLockScroll } from '@lib/stores/main-layout.store';
	import { lockscroll } from '@svelte-put/lockscroll';
	import { toasterPosition } from '@lib/stores/main-layout.store';
	import { fly } from 'svelte/transition';
	import refreshIcon from '@lib/images/icons/3d/refresh.webp?enhanced';

	export let data;

	NProgress.configure({ minimum: 0.16, showSpinner: false });

	$: metaTags = merge({}, data.baseMetaTags, $page.data.pageMetaTags);
	$: $navigating ? NProgress.start() : NProgress.done();
	$: isUpdated = $updated ? '' : 'off';
	$: isOpenUpdateToast = $updated;
</script>

<MetaTags {...metaTags} />

<svelte:head>
	<!-- Meta Pixel Code -->
	{@html `<script>
	!function(f,b,e,v,n,t,s)
	{if(f.fbq)return;n=f.fbq=function(){n.callMethod?
	n.callMethod.apply(n,arguments):n.queue.push(arguments)};
	if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
	n.queue=[];t=b.createElement(e);t.async=!0;
	t.src=v;s=b.getElementsByTagName(e)[0];
	s.parentNode.insertBefore(t,s)}(window, document,'script',
	'https://connect.facebook.net/en_US/fbevents.js');
	fbq('init', '985289460041633');
	fbq('track', 'PageView');
	</script>
	<noscript><img height="1" width="1" style="display:none"
	src="https://www.facebook.com/tr?id=985289460041633&ev=PageView&noscript=1"
	/></noscript>`}
	<!-- End Meta Pixel Code -->

	<!-- Google tag (gtag.js) -->
	{@html `<script async src="https://www.googletagmanager.com/gtag/js?id=G-GHVBKQ4B0Y"></script>
	<script>
	window.dataLayer = window.dataLayer || [];
	function gtag(){dataLayer.push(arguments);}
	gtag('js', new Date());
	gtag('config', 'G-GHVBKQ4B0Y');
	</script>`}
	<!-- End Google tag (gtag.js) -->
</svelte:head>

<svelte:body use:lockscroll={$isLockScroll} />

<main
	data-sveltekit-reload={isUpdated}
	class="min-h-dvh font-poppins text-neutral"
	style="padding-bottom: {$additionalPaddingBottom}px"
>
	<Toaster class="font-poppins" position={$toasterPosition} richColors closeButton />
	<slot />
	{#if isOpenUpdateToast}
		<div class="fixed bottom-16 z-[999] w-full p-5 pre-md:bottom-0 pre-md:max-w-fit">
			<div class="rounded-xl bg-white p-5 shadow-soft" transition:fly={{ y: 100 }}>
				<div class="flex items-center gap-4">
					<enhanced:img class="size-14" src={refreshIcon} alt="Refresh" />
					<div class="flex-1">
						<p class="mb-1 text-lg font-semibold text-secondary">Oops, ada pembaruan nih!</p>
						<p class="text-sm">Harap refresh browser untuk mengambil perubahan.</p>
					</div>
				</div>
				<div class="mt-6 flex items-center gap-2">
					<button type="button" class="btn btn-secondary" on:click={() => location.reload()}>
						<RoundRefresh class="text-lg" />
						Refresh
					</button>
					<button on:click={() => (isOpenUpdateToast = false)} type="button" class="btn">
						Nanti aja
					</button>
				</div>
			</div>
		</div>
	{/if}
</main>
